// components/Reusables/CategoryColumnConfig/CategoryColumnConfig.jsx
import React, { useState } from 'react';

const CategoryColumnConfig = ({ category, tableColumns = [], displaySettings: initialDisplaySettings, onSave, onClose }) => {
    console.log("Table Columns: ", tableColumns)
    const [columns, setColumns] = useState(tableColumns);
    const [displaySettings, setDisplaySettings] = useState(initialDisplaySettings || {
        primaryIdentifier: "name",
        primaryVendorProperty: "",
        showVendorPropertiesInTable: true
    });
    const [newColumn, setNewColumn] = useState({ header: "", isVisible: true });

    const addColumn = () => {
        if (newColumn.header.trim()) {
            setColumns([
                ...columns,
                {
                    header: newColumn.header,
                    displayOrder: columns.length,
                    isVisible: true
                }
            ]);
            setNewColumn({ header: "", isVisible: true });
        } else {
            alert('Please enter a column header');
        }
    };

    const updateColumn = (index, field, value) => {
        const updated = [...columns];
        updated[index][field] = value;
        setColumns(updated);
    };

    const removeColumn = (index) => {
        if (window.confirm('Remove this column?')) {
            setColumns(columns.filter((_, i) => i !== index));
        }
    };

    const handleSave = () => {
        onSave({
            tableColumns: columns.map((col, idx) => ({
                header: col.header,
                displayOrder: idx,
                isVisible: col.isVisible
            })),
            displaySettings
        });
    };

    const visibleColumns = columns.filter(col => col.isVisible);

    return (
        <div className="p-3">
            <h5>Configure Table Columns for {category?.name}</h5>
            <p className="text-muted small">
                Define the column headers that will appear in the raw materials table.
                When adding vendor properties, you'll map them to these headers.
            </p>

            {/* Display Settings */}
            <div className="card mb-3">
                <div className="card-header">
                    <h6 className="mb-0">Display Settings</h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <label className="form-label">Primary Identifier</label>
                            <select
                                className="form-select"
                                value={displaySettings.primaryIdentifier}
                                onChange={(e) => setDisplaySettings({
                                    ...displaySettings,
                                    primaryIdentifier: e.target.value
                                })}
                            >
                                <option value="name">Item Name Field</option>
                                <option value="vendorProperty">Vendor Property</option>
                            </select>
                            <small className="text-muted">What to display as the main identifier in the table</small>
                        </div>

                        {displaySettings.primaryIdentifier === "vendorProperty" && (
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Primary Vendor Property</label>
                                <select
                                    className="form-select"
                                    value={displaySettings.primaryVendorProperty || ""}
                                    onChange={(e) => setDisplaySettings({
                                        ...displaySettings,
                                        primaryVendorProperty: e.target.value
                                    })}
                                >
                                    <option value="">Select column...</option>
                                    {visibleColumns.map(col => (
                                        <option key={col.header} value={col.header}>
                                            {col.header}
                                        </option>
                                    ))}
                                </select>
                                <small className="text-muted">Which column to use as the item name</small>
                            </div>
                        )}

                        <div className="col-md-12">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="showVendorProps"
                                    checked={displaySettings.showVendorPropertiesInTable}
                                    onChange={(e) => setDisplaySettings({
                                        ...displaySettings,
                                        showVendorPropertiesInTable: e.target.checked
                                    })}
                                />
                                <label className="form-check-label" htmlFor="showVendorProps">
                                    Show vendor properties as table columns
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Column Definitions */}
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">Table Columns</h6>
                    <div className="d-flex gap-2">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="New column header"
                            style={{ width: '200px' }}
                            value={newColumn.header}
                            onChange={(e) => setNewColumn({ ...newColumn, header: e.target.value })}
                        />
                        <button className="btn btn-sm btn-primary" onClick={addColumn}>
                            Add
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    {columns.length > 0 ? (
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Column Header</th>
                                    <th>Visible</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {columns.map((col, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={col.header}
                                                onChange={(e) => updateColumn(idx, 'header', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={col.isVisible}
                                                onChange={(e) => updateColumn(idx, 'isVisible', e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => removeColumn(idx)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="text-muted text-center p-3">
                            No columns defined. Add columns to display vendor properties.
                        </div>
                    )}
                </div>
            </div>

            <div className="mt-3 d-flex justify-content-end gap-2">
                <button className="btn btn-secondary" onClick={onClose}>
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSave}>
                    Save Configuration
                </button>
            </div>
        </div>
    );
};

export default CategoryColumnConfig;